// External 
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// Local
import { getProblemById } from "../../../Data/ProblemsMethod";
import TestCaseButton from "./TestCaseButton"

// CSS
import "./AllTestCases.css"



export default function AllTestCases({judge0APIResponseJSON, setProblemAccepted}){

    const { state } = useLocation(); // Unpack { state: { problem_id : problemID } }); 
    const problemID = state.problem_id;    
    const currProblem = getProblemById(problemID);
    const inputArray = currProblem.input;
    const expectedOutputArray = currProblem.expected_output;

    const [selected_test, set_selected_test] = useState(0)
    const [input, set_input] = useState(inputArray[selected_test])
    const [expected_output, set_expected_output] = useState(expectedOutputArray[selected_test])
    useEffect(() =>{
        set_input(inputArray[selected_test])
        set_expected_output(expectedOutputArray[selected_test])
     }, [selected_test])

    const [testcase_passed, set_testcase_passed] = useState(Array(expectedOutputArray.length).fill("Await Submission"));
    const [error_message_arr, set_error_message_arr] = useState(Array(expectedOutputArray.length).fill(""));
 





    const testCaseButtons = inputArray.map((input, idx) => 
        <div className="button-test-case-container">
            <TestCaseButton selectedTest={selected_test} setSelectedTest={set_selected_test} testCaseID={idx} passed={testcase_passed[idx]}/>
        </div>
    );

    useEffect(() =>{

    },[inputArray])





    // Used to check if response is correct
    useEffect(() => {
        if(judge0APIResponseJSON?.data?.submissions?.length > 0){
            try{
                const response_array = judge0APIResponseJSON?.data?.submissions;
                let graded_array = [];
                let error_array = Array(expectedOutputArray.length).fill("");
                let problem_accepted = true;
                for(let i = 0; i < response_array.length; i++) {
                    
                    let statusId = judge0APIResponseJSON?.data?.submissions?.[i]?.status?.id;
                    let currProbHasErr = !(statusId === 3 || statusId === 4);  // Accepted solution || Failed solution
                    if(currProbHasErr){
                        const errMsg = 
                        judge0APIResponseJSON?.data?.submissions?.[i]?.compile_output !== null ?
                        judge0APIResponseJSON?.data?.submissions?.[i]?.compile_output :
                        judge0APIResponseJSON?.data?.submissions?.[i]?.stderr !== null ?
                        judge0APIResponseJSON?.data?.submissions?.[i]?.stderr :  "Error Running Code";
                        error_array[i] = errMsg
                    }

                    if(response_array[i]?.status?.description != null){
                        graded_array.push(response_array[i]?.status?.description === "Accepted" ? "Accepted" : "Failed")
                        if(response_array[i]?.status?.description !== "Accepted"){
                            problem_accepted = false;
                        }
                    }else{
                        graded_array.push("Failed")
                        problem_accepted = false;
                    }
                }
                if(problem_accepted === false)
                    setProblemAccepted("Failed");
                if(problem_accepted === true)
                    setProblemAccepted("Accepted");

                set_error_message_arr(error_array);
                set_testcase_passed(graded_array);
            }
            catch(e){
                console.log("[ERROR] Failed to grade code submission", e)
                console.log("[RESPONSE] ", judge0APIResponseJSON)
            }
        } 
    },[judge0APIResponseJSON])



    return(
        <>
        {
            <div className="all-test-cases-wrapper">
                <div className="test-buttons-wrapper">
                    {testCaseButtons}
                </div>

                <div className="input-expected-output-container">

                    <div className="input-wrapper"> 
                        Input:
                        <div className="input">
                            <div className="input-text">
                                {input}
                            </div>
                        </div>
                    </div>

                    <div className="expected-output-wrapper">
                        Expected Output:
                        <div className="expected-output">
                            <div className="expected-output-text">
                                {expected_output}
                            </div>
                        </div>
                    </div>

                {
                    (testcase_passed[0] !== "Await Submission" ) && 
                    (
                        error_message_arr[selected_test] === "" ?
                        (
                            <>
                                <div className="actual-output-wrapper">
                                    Actual Output:
                                    <div className="actual-output">
                                        <div className="actual-ouput-text">
                                            {judge0APIResponseJSON.data.submissions[selected_test].functionReturnValue}
                                        </div>
                                    </div>
                                </div> 
                                {
                                (judge0APIResponseJSON.data.submissions[selected_test]?.userPrint !== null && judge0APIResponseJSON.data.submissions[selected_test]?.userPrint !== "") && 
                                    <div className="actual-output-wrapper">
                                        STDOUT:
                                        <div className="actual-output">
                                            <div className="actual-ouput-text">
                                                {judge0APIResponseJSON.data.submissions[selected_test].userPrint}
                                            </div>
                                        </div>
                                    </div> 
                                }
                            </>
                        )
                        :
                        <div className="run-code-error-message-wrapper">
                            <div className="run-code-error-message">
                                    {error_message_arr[selected_test]}
                            </div>
                        </div>
                      
                    )
                }
                </div>
            </div> 
           
        }
        </>
       
        
    );
}